import {useState, useEffect, useMemo} from 'react';
import {COUNTRY_LANGUAGES_CODES} from '@/utils/constants/globalConstants';
import {getDisplayContentLanguagesService} from '@/services/languageService';

/**
 * Hook to manage language state for rewards display
 * Derives languages from country code or fetches fallback
 */
export const useRewardsDisplayLanguages = ({
  countryCode,
  displayContentLanguages
}) => {
  const [localLanguages, setLocalLanguages] = useState([]);

  useEffect(() => {
    const countryLangs = COUNTRY_LANGUAGES_CODES[countryCode];
    if (countryLangs?.length > 0) {
      setLocalLanguages(countryLangs);
      return;
    }
    if (displayContentLanguages?.length > 0) {
      setLocalLanguages(displayContentLanguages);
      return;
    }

    let isMounted = true;
    getDisplayContentLanguagesService().then((res) => {
      if (isMounted) setLocalLanguages(res || []);
    });
    return () => {
      isMounted = false;
    };
  }, [countryCode, displayContentLanguages]);

  const languages = useMemo(
    () =>
      (localLanguages || []).map((l) => ({
        code: l.code,
        language: l.language || l.title
      })),
    [localLanguages]
  );

  return {languages, localLanguages};
};
